<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>

    <div class="modal-body">
      <div class="col-md-7 form-group">
        <input class="form-control" placeholder="Assignment name" [(ngModel)]="data.ActivitySequence.Name">
      </div>
      <div class="d-flex">
        <div class="col-md-3 form-group">
          <div class="detail-name">Start</div>
          <div class="addAssignmentDatePicker" [ngClass]="{invalid:validator.StartDate === 0 || validator.DateRange === 0}"> 
              <app-assignment-date-picker [(model)]="data.StartDate" [isStartDate]="true" [disabled]="invalidName()" 
                  (modelChange)="validateStartDate()" [otherDate]="data.EndDate">
              </app-assignment-date-picker>
          </div>
          <div class="italic error-message" *ngIf="validator.StartDate === 0">Must provide a valid Start date</div>
        </div>
        <div class="col-md-3 form-group">
          <div class="detail-name">End</div>
          <div class="addAssignmentDatePicker" [ngClass]="{invalid:validator.EndDate === 0 || validator.DateRange === 0}">
            <app-assignment-date-picker [(model)]="data.EndDate" [isStartDate]="false" [disabled]="invalidName()" 
                (modelChange)="validateEndDate()" [otherDate]="data.StartDate">
            </app-assignment-date-picker>
          </div>
          <div class="italic error-message" *ngIf="validator.EndDate === 0">Must provide a valid End date</div>
        </div>
      </div>

      <div class="d-flex col">
        <div style="width:100%">
          <div class="detail-name">Assign Students</div>
          <div ngbDropdown #studentsDropdown="ngbDropdown">
            <button type="button" class="btn btn-outline-secondary" id="dropdownForm1" style="color: black; font-weight: normal;" ngbDropdownToggle>
              {{ getAssignedStudentsText() }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm1">
              <div class="d-flex hover" (click)="assignToAllStudents()">
                <input class="m-1" type="checkbox" [checked]="allStudentsAssigned()">
                <div class="m-1">All Students</div>
              </div>
              <div class="scrollable">
                <div *ngFor="let assignedStudent of assignedStudents" class="d-flex hover mr-1" (click)="toggleStudent(assignedStudent)">
                  <input class="m-1" type="checkbox" [(ngModel)]="assignedStudent.include">
                  <div class="m-1">{{assignedStudent.student.Name}}</div>
                </div>
              </div>
              <div class="d-flex">
                <button type="button" class="btn btn-outline-secondary m-1" (click)="cancelAssignedStudents()">Cancel</button>
                <button type="button" class="btn btn-disabled m-1" style="background-color: grey; color:white;" (click)="saveAssignedStudents(); studentsDropdown.close();">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 italic error-message" *ngIf="validator.DateRange === 0">
        Start date must not be after End date.
      </div>
    </div>

    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting" text="Saving..."></app-loading-spinner>
    </div>

</ng-template>

<button *ngIf="openModalButtonVisible" class="btn btn-primary" (click)="openForNew()">Add New Assignment</button>